module.exports = __webpack_public_path__ + "static/media/vegitables_57.140db75b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_57.csv
// module id = 643
// module chunks = 0